import {Component} from 'san';

import styles from './style/index.module.less';

export default class TopList extends Component {
    static template = require('./index.html');
    static computed = {
        topList() {
            let data = this.data.get('data');
            let num = this.data.get('num');
            let topList = data.slice(10 * num, 10 + 10 * num);
            return topList;
        },
    }
    static filters = {
        handleIndex(index) {
            if (index <= 2) {
                const styles = this.data.get('styles');
                let topListIndex = `topListIndex-${index}`;
                return styles[topListIndex];
            }
        },
        hotTag(index) {
            const styles = this.data.get('styles');
            let hotTagClass = `hotTag-${index}`;
            return styles[hotTagClass];
        },
    }
    initData() {
        return {
            styles,
            num: 0,
        };
    }
    attached() {
        const nid = this.data.get('nid');
        this.storeDispatch('hotTopList:showLog', {nid});
        this.storeDispatch('hotTopChange:showLog', {nid});
    }
    clickHandler(index) {
        this.storeDispatch('hotTopList:clkLog', {pos: index});
    }
    handleChange() {
        const rotate = this.ref('rotate');
        const nid = this.data.get('nid');
        let num = this.data.get('num');
        let timer = null;
        this.storeDispatch('hotTopChange:clkLog', {nid});
        rotate.classList.add('rotateClass');
        if (timer) {
            clearTimeout(timer);
        };
        timer = setTimeout(() => {
            rotate.classList.remove('rotateClass');
        }, 300);
        if (num === 2) {
            this.data.set('num', 0);
            return;
        }
        this.data.set('num', ++num);
    }
    handleHotTag(hotTag) {
        switch (hotTag) {
            case '0':
                return '';
            case '1':
                return '新';
            case '2':
                return '商';
            case '3':
                return '热';
            case '4':
                return '沸';
            case '5':
                return '爆';
        }
    }
}